export const SEND_MESSAGE = "SEND_MESSAGE"
export const SEND_MESSAGE_FAIL = "SEND_MESSAGE_FAIL"
export const CLEAR_MESSAGE = "CLEAR_MESSAGE"
export const MESSAGE_IS_PENDING = "MESSAGE_IS_PENDING"
export const REQUEST_FAILED = "REQUEST_FAILED"
export const CLEAR_REQUEST = "CLEAR_REQUEST"
export const REQUEST_SEND = "REQUEST_SEND"